"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let RentalService = class RentalService extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    rental;
    onRental(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("rental");
    }
    meter;
    onMeter(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("meter");
    }
    preventEditRental;
    onPrevent_edit_rental(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("preventEditRental");
    }
    preventEditMeter;
    onPrevent_edit_meter(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("preventEditMeter");
    }
    assignToRental;
    onAssign_to_rental(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("assignToRental");
    }
    assignToMeter;
    onAssign_to_meter(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("assignToMeter");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    item;
    async $$load_item() {
        return this.oid
            ? this.$fn.fetch('read_rental_service', { parameters: { id: this.oid } })
            : this.$fn.fetch('get_rental_service_defaults', {
                parameters: {
                    meter_id: this.meter ? this.meter.id : null,
                    rental_id: this.rental ? this.rental.id : null,
                }
            });
    }
    units;
    async $$load_units() {
        return this.$fn.fetch('list_unit').then(d => _.orderBy(d, [p => p.symbol.toLowerCase()]));
    }
    formName;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    labelAlign;
    isReadOnly;
    async $$load_isReadOnly() {
        return this.item.locked;
    }
    tariffs;
    async $$load_tariffs() {
        return this.$app.repo.get('list_object_by_type', { parameters: { object_type: 'tariff' } });
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2070266589801014_dataSource;
    b_5074589820235598_dataSource;
    dataMembers = ['item', 'units', 'formName', 'formId', 'labelAlign', 'isReadOnly', 'tariffs', 'ux', 'b_7315092382398562_modalBindings', 'b_2070266589801014_dataSource', 'b_5074589820235598_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                units: null,
                formName: "rentalService",
                formId: null,
                labelAlign: "right",
                isReadOnly: null,
                tariffs: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    noPrimaryButton: true,
                    closeButtonText: this.$fn.gettext("Close"),
                    size: "lg",
                },
                b_2070266589801014_dataSource: {
                    name: "suggest_meter",
                },
                b_5074589820235598_dataSource: {
                    name: "suggest_product",
                    parameters: {
                        product_types: "service",
                    },
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.oid ? this.$fn.gettext('Edit Rental Service') : this.$fn.gettext('Add Rental Service'),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_9496_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_9502_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                ok: true,
                value: $event.data.response.data,
            },
        };
    }
    async act_1040167445267876_request_9500_getActionArgs($event) {
        return {
            operation: this.item.id ? 'update_rental_service' : 'create_rental_service',
            data: _.extend(this.item, { rental_id: this.item.rental.id }),
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_2070266589801014_script_9506_getActionArgs_value($event) {
        _.extend(this.item, $event.data.response.data);
    }
    async act_2070266589801014_script_9506_getActionArgs($event) {
        return {
            value: () => this.act_2070266589801014_script_9506_getActionArgs_value($event),
        };
    }
    async act_2070266589801014_request_9504_getActionArgs($event) {
        return {
            operation: "get_rental_service_defaults",
            data: {
                rental_id: this.rental ? this.rental.id : this.item.rental_id,
                meter_id: this.item.meter.id,
            },
        };
    }
    async evh_2070266589801014_optionSelected(event, scope) {
        return await this.actions.evh_2070266589801014_optionSelected.executeFromDOM(this, event, scope);
    }
    async act_5074589820235598_setData_9508_getActionArgs($event) {
        return {
            path: "item.service_id",
            value: this.item.service.id,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_5074589820235598_setData_9510_getActionArgs($event) {
        return {
            path: "item.name",
            value: $event.data.option.name,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_5074589820235598_optionSelected(event, scope) {
        return await this.actions.evh_5074589820235598_optionSelected.executeFromDOM(this, event, scope);
    }
    async act_2140198529698299_closeModal_9512_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async evh_2140198529698299_success(event, scope) {
        return await this.actions.evh_2140198529698299_success.executeFromDOM(this, event, scope);
    }
    async act_2434514588044777_closeModal_9514_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async evh_2434514588044777_success(event, scope) {
        return await this.actions.evh_2434514588044777_success.executeFromDOM(this, event, scope);
    }
    async act_2186679009640457_closeModal_9516_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                cancel: true,
            },
        };
    }
    async evh_2186679009640457_clickPreventStop(event, scope) {
        return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_9496 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_9496_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_9495 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_9496,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_9495],
        });
        const act_2248226175642056_closeComponent_9498 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_9497 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_9498,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_9497],
        });
        const act_1040167445267876_closeModal_9502 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_9502_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_9501 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_9502,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_request_9500 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_9500_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_9501],
        });
        const evh_1040167445267876_submit_9499 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_9500,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_9499],
        });
        const act_2070266589801014_script_9506 = new core_1.actions.ScriptAction({
            actionArgs: this.act_2070266589801014_script_9506_getActionArgs,
            events: [],
        });
        const evh_2070266589801014_success_9505 = new core_1.actions.EventHandlerImpl({
            action: act_2070266589801014_script_9506,
            event: "success",
            displayName: "script",
        });
        const act_2070266589801014_request_9504 = new core_1.actions.RequestAction({
            actionArgs: this.act_2070266589801014_request_9504_getActionArgs,
            displayName: "getDefaultsOnMeterSelected",
            events: [evh_2070266589801014_success_9505],
        });
        const evh_2070266589801014_optionSelected_9503 = new core_1.actions.EventHandlerImpl({
            action: act_2070266589801014_request_9504,
            event: "optionSelected",
            displayName: "getDefaultsOnMeterSelected",
        });
        const evh_2070266589801014_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2070266589801014_optionSelected_9503],
        });
        const act_5074589820235598_setData_9508 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5074589820235598_setData_9508_getActionArgs,
            events: [],
        });
        const evh_5074589820235598_optionSelected_9507 = new core_1.actions.EventHandlerImpl({
            action: act_5074589820235598_setData_9508,
            event: "optionSelected",
            displayName: "setData",
        });
        const act_5074589820235598_setData_9510 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5074589820235598_setData_9510_getActionArgs,
            events: [],
        });
        const evh_5074589820235598_optionSelected_9509 = new core_1.actions.EventHandlerImpl({
            action: act_5074589820235598_setData_9510,
            event: "optionSelected",
            displayName: "setData",
        });
        const evh_5074589820235598_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5074589820235598_optionSelected_9507, evh_5074589820235598_optionSelected_9509],
        });
        const act_2140198529698299_closeModal_9512 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_2140198529698299_closeModal_9512_getActionArgs,
            events: [],
        });
        const evh_2140198529698299_success_9511 = new core_1.actions.EventHandlerImpl({
            action: act_2140198529698299_closeModal_9512,
            event: "success",
            displayName: "closeModal",
        });
        const evh_2140198529698299_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2140198529698299_success_9511],
        });
        const act_2434514588044777_closeModal_9514 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_2434514588044777_closeModal_9514_getActionArgs,
            events: [],
        });
        const evh_2434514588044777_success_9513 = new core_1.actions.EventHandlerImpl({
            action: act_2434514588044777_closeModal_9514,
            event: "success",
            displayName: "closeModal",
        });
        const evh_2434514588044777_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2434514588044777_success_9513],
        });
        const act_2186679009640457_closeModal_9516 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_2186679009640457_closeModal_9516_getActionArgs,
            events: [],
        });
        const evh_2186679009640457_clickPreventStop_9515 = new core_1.actions.EventHandlerImpl({
            action: act_2186679009640457_closeModal_9516,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_2186679009640457_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2186679009640457_clickPreventStop_9515],
        });
        return {
            act_7315092382398562_closeModal_9496,
            evh_7315092382398562_close_9495,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_9498,
            evh_2248226175642056_close_9497,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_9502,
            evh_1040167445267876_success_9501,
            act_1040167445267876_request_9500,
            evh_1040167445267876_submit_9499,
            evh_1040167445267876_submit,
            act_2070266589801014_script_9506,
            evh_2070266589801014_success_9505,
            act_2070266589801014_request_9504,
            evh_2070266589801014_optionSelected_9503,
            evh_2070266589801014_optionSelected,
            act_5074589820235598_setData_9508,
            evh_5074589820235598_optionSelected_9507,
            act_5074589820235598_setData_9510,
            evh_5074589820235598_optionSelected_9509,
            evh_5074589820235598_optionSelected,
            act_2140198529698299_closeModal_9512,
            evh_2140198529698299_success_9511,
            evh_2140198529698299_success,
            act_2434514588044777_closeModal_9514,
            evh_2434514588044777_success_9513,
            evh_2434514588044777_success,
            act_2186679009640457_closeModal_9516,
            evh_2186679009640457_clickPreventStop_9515,
            evh_2186679009640457_clickPreventStop,
            submit: act_1040167445267876_request_9500,
            getDefaultsOnMeterSelected: act_2070266589801014_request_9504,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: null,
    }),
    __metadata("design:type", String)
], RentalService.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RentalService.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
        default: null,
    }),
    __metadata("design:type", Object)
], RentalService.prototype, "rental", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('rental'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RentalService.prototype, "onRental", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
        default: null,
    }),
    __metadata("design:type", Object)
], RentalService.prototype, "meter", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('meter'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RentalService.prototype, "onMeter", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: false,
    }),
    __metadata("design:type", Boolean)
], RentalService.prototype, "preventEditRental", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('preventEditRental'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RentalService.prototype, "onPrevent_edit_rental", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: false,
    }),
    __metadata("design:type", Boolean)
], RentalService.prototype, "preventEditMeter", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('preventEditMeter'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RentalService.prototype, "onPrevent_edit_meter", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: false,
    }),
    __metadata("design:type", Boolean)
], RentalService.prototype, "assignToRental", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('assignToRental'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RentalService.prototype, "onAssign_to_rental", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: false,
    }),
    __metadata("design:type", Boolean)
], RentalService.prototype, "assignToMeter", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('assignToMeter'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RentalService.prototype, "onAssign_to_meter", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], RentalService.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RentalService.prototype, "onSize", null);
RentalService = __decorate([
    (0, vue_property_decorator_1.Component)()
], RentalService);
exports.default = RentalService;
vue_property_decorator_1.Vue.component("RentalService", RentalService);
